/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';
import NextLink from 'next/link';

import { useInt } from 'hooks/useInt';

import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './ReadingPath.module.scss';

import { SectionShell } from '../../atoms/SectionShell/SectionShell';
import { topicPath } from '../../paths';
import type { ReadingPathProps } from './ReadingPath.types';

export const ReadingPath = ({ readingPath, family, lang, className }: ReadingPathProps) => {
  const { t } = useInt();

  if (!readingPath.length) {
    return null;
  }

  return (
    <SectionShell id="reading-path" title={t('Continue learning')} className={cn(styles['section'], className)}>
      <ol className={styles['list']}>
        {readingPath.map((link, index) => (
          <li key={link.slug}>
            <NextLink href={topicPath(link.slug, lang)} className={styles['link']}>
              <span className={styles['number']}>{String(index + 1).padStart(2, '0')}</span>

              <span className={styles['name']}>{link.name}</span>

              <Icon type="arrow-forward" />
            </NextLink>
          </li>
        ))}
      </ol>

      <NextLink href={family.href} className={styles['family']}>
        {t('Explore {family}').replace('{family}', family.name)}
        <Icon type="arrow-forward" />
      </NextLink>
    </SectionShell>
  );
};
